import axiosInstance from "../axios"
import type { MaterialDetail } from "../types/calculadoraDeMateriales.ts"

const getAuthHeaders = () => {
  const authToken = localStorage.getItem("access-Token-Edify")
  return { headers: { Authorization: `Bearer ${authToken}` } }
}

export async function getMaterialById(materialId: number | string): Promise<MaterialDetail> {
  const response = await axiosInstance.get(`/materials/${encodeURIComponent(String(materialId))}`, getAuthHeaders())
  const raw = response.data as Record<string, unknown>
  const data = (raw?.data ?? raw) as MaterialDetail
  return data
}
